import React, { useEffect, useState } from "react";
import { withLocalize } from "react-localize-redux";
import translations from "../../translations/profile.json";
import { DetailType } from "wallet-elementkit/dist/translations";
import NoUserAvatar from "../../assets/images/profile-no-user-avatar.png";

import {
	getCredentialsByEmail,
	getUserInfo,
} from "../../services/verifiedBackendService/user";
import NotFound from "../../components/common/NotFound";

import "../../styles/app.scss";
import "../../styles/credentials/credentials.scss";
import ProfileHeader from "../../components/profile/ProfileHeader/ProfileHeader";
import ProfileTabs from "../../components/profile/ProfileTabs";
import {
	useHistory,
	useLocation,
	useParams,
} from "react-router-dom/cjs/react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { selectUser, userActions } from "../../store/features/user";
import {
	getProfile,
	updateProfile,
} from "../../services/verifiedBackendService/profile";
import Notification from "../../components/notification/Notification";
import { getToken } from "../../backend/StorageUtils";
import { OptimizedMixPanel } from "wallet-elementkit/dist/services";
import mixpanel from "mixpanel-browser";

const Credentials = (props) => {
	const userMeta = useAppSelector(selectUser);
	const params = useParams();
	const location = useLocation();
	const dispatch = useAppDispatch();
	const [certificates, setCertificates] = useState([]);
	const [errorMessage, setErrorMessage] = useState(false);
	const [userFullName, setUserFullName] = useState("");
	const [userPhoto, setUserPhoto] = useState("");
	const [credentials, setCredentials] = useState([]);
	const [isLoggedInUserProfile, setIsLoggedInUserProfile] = useState(
		userMeta.user.username === params.username || false
	);
	const history = useHistory();
	const [isEmailConfirmed, setIsEmailConfirmed] = useState(true);
	const [activeTab, setActiveTab] = useState("credentials");
	const [profileUser, setProfileUser] = useState();
	const [profileLoading, setProfileLoading] = useState(true);
	const [userWalletData, setUserWalletData] = useState();
	const [linkedinProfileUrl, setLinkedinProfileUrl] = useState("");
	const [profileNotFound, setProfileNotFound] = useState(false);
	const [editModeActive, setEditModeActive] = useState(false);
	const [credentialsToBeUpdated, setCredentialsToBeUpdated] = useState({});
	const optimizedMixpanel = new OptimizedMixPanel(mixpanel);
	useEffect(() => {
		props.addTranslation(translations);
	}, []);

	const goToCredentials = (categoryNo) => {
		history.push({
			pathname: `/${props.activeLanguage?.code ?? "en"}/credentials/${
				props.username
			}/${categoryNo}`,
		});
	};

	const initProfile = async () => {
		setProfileLoading(true);
		await Promise.all([fetchWalletProfile(), getCertificates()]);
		setProfileLoading(false);
	};

	const getCertificates = async () => {
		if (props) {
			try {
				let resp = await getCredentialsByEmail(
					decodeURIComponent(props.username)
				);
				resp.credentials.forEach((element) => {
					element.type = DetailType[props.activeLanguage.code][element.type];
					if (!element.logoLink) {
						element.logoLink =
							require("../../assets/fallbacks/organization.svg").default;
					}
				});
				setCertificates(resp.credentials);
				setUserFullName(resp.user.userFullName);
				setUserPhoto(resp.user.userPhoto);
			} catch {
				setErrorMessage("notFound");
			}
		}
	};

	function getBase64(file, cb) {
		let reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = function () {
			cb(reader.result);
		};
		reader.onerror = function (error) {
			console.log("Error on base64 conversion: ", error);
		};
	}

	function cancelEditMode() {
		setCredentialsToBeUpdated({});
		setEditModeActive(false);
	}

	function enterEditMode() {
		setActiveTab("credentials");
		setEditModeActive(true);
	}

	const fetchCredentials = async (credDeleted = false) => {
		let credentials = null;
		if (
			userMeta.credentials &&
			!credDeleted &&
			userMeta.user.username === params.username
		) {
			credentials = JSON.parse(JSON.stringify(userMeta.credentials));
		} else {
			// No Velocity Action
			// setProfileLoading(true);
			// credentials = await getCredentials(
			// 	isLoggedInUserProfile,
			// 	params.username
			// );
		}
		if (credentials) {
			// setVelocityCredentials(credentials);
			if (userMeta.user.username === params.username)
				dispatch(userActions.setCredentials(credentials));
		}
	};

	async function getUserInfoForMeta() {
		const token = getToken();
		if (!token) return;

		await getUserInfo(getToken()).then((userData) => {
			if (userData !== null && userData.success) {
				dispatch(userActions.setUser(userData.user));
				dispatch(userActions.setUserWalletData(userData.userWalletData));
				dispatch(userActions.setUserEmails(userData.userEmails));
				dispatch(userActions.setAllUserWallets(userData.allUserWallets));
				dispatch(userActions.setLogged(true));
				dispatch(userActions.setIsMailConfirmed(true));
			}
		});
	}

	async function updateWalletProfile(
		newName,
		newProfileInfo,
		newAvatar,
		newBanner,
		newAvatarFileExtension,
		newBannerFileExtension,
		linkedinProfileUrl
	) {
		let params = {
			name: newName === userMeta.user.name ? undefined : newName,
			profile_info:
				newProfileInfo === userMeta.user.profile_info
					? undefined
					: newProfileInfo,
			linkedinProfileUrl: linkedinProfileUrl,
			profilePic: newAvatar,
			profileBanner: newBanner,
			profileFileExtension: newAvatarFileExtension,
			bannerFileExtension: newBannerFileExtension,
			credentialVisibility:
				Object.keys(credentialsToBeUpdated).length === 0
					? undefined
					: credentialsToBeUpdated,
		};
		let profileResponse = await updateProfile(params);
		if (profileResponse) {
			Notification({
				type: "success",
				text: props.translate("changesSaved"),
			});
			setProfileUser(profileResponse.user);
			setUserWalletData(profileResponse.userWalletData);
		} else {
			Notification({
				type: "error",
				text: props.translate("anErrorOccurred"),
			});
		}
		setCredentialsToBeUpdated({});
		setEditModeActive(false);
		fetchWalletProfile();
		getUserInfoForMeta();
	}

	async function fetchWalletProfile() {
		setProfileNotFound(false);

		let profileResponse = await getProfile(
			params.username,
			userMeta.user.username === params.username
		);
		optimizedMixpanel.track("Profile Visit", {
			username: params.username,
			isLogged: userMeta.logged,
			ownership: isLoggedInUserProfile,
		});
		if (profileResponse) {
			setCredentials(profileResponse.credentials);
			setProfileUser(profileResponse.user);
			setUserWalletData(profileResponse.userWalletData);
			setLinkedinProfileUrl(profileResponse.linkedinProfileUrl || "");
		} else {
			setProfileNotFound(true);
		}
		await fetchCredentials();
	}

	useEffect(() => {
		setIsEmailConfirmed(userMeta.isMailConfirmed);
	}, [userMeta, userMeta.isMailConfirmed]);

	useEffect(() => {
		setIsLoggedInUserProfile(userMeta.user.username === params.username);
		initProfile();
	}, [params.username, userMeta.user.username]);

	useEffect(() => {
		// Reset edit mode when params.username changes
		setEditModeActive(false);
	}, [params.username]);

	if (!props.isMobile) {
		return !errorMessage ? (
			<div className="profile-anon-main">
				<ProfileHeader
					{...props}
					name={profileUser?.name ?? ""}
					description={profileUser?.profile_info ?? ""}
					credentialCount={
						certificates.filter((cert) => cert.url !== "").length +
						certificates.filter((badge) => badge.badgeUrl !== "").length
					}
					bannerUrl={userWalletData?.profileBannerImageUrl}
					imageUrl={profileUser?.profile_url ?? NoUserAvatar}
					editModeActive={editModeActive}
					getBase64={getBase64}
					cancelEditMode={cancelEditMode}
					enterEditMode={enterEditMode}
					updateWalletProfile={updateWalletProfile}
					isLoading={profileLoading}
					goToCredentials={goToCredentials}
					isLoggedInUserProfile={isLoggedInUserProfile}
					activeTab={activeTab}
					addTranslation={props.addTranslation}
					linkedinProfileUrl={linkedinProfileUrl}
				/>
				<ProfileTabs
					{...props}
					editModeActive={editModeActive}
					isMobile={props.isMobile}
					certificates={certificates.filter((cert) => cert.url !== "")}
					badges={certificates.filter((badge) => badge.badgeUrl !== "")}
					userFullName={userFullName}
					userPhoto={userPhoto}
					isLoading={profileLoading}
					goToCredentials={goToCredentials}
					activeLanguage={props.activeLanguage}
					setCredentialsToBeUpdated={setCredentialsToBeUpdated}
					isLoggedInUserProfile={isLoggedInUserProfile}
					profileCredentials={credentials}
					activeTab={activeTab}
					setActiveTab={setActiveTab}
				/>
			</div>
		) : (
			<NotFound errorMessage={errorMessage} />
		);
	} else {
		return !errorMessage ? (
			<div className="profile-anon-main-mobile">
				<ProfileHeader
					{...props}
					name={profileUser?.name ?? ""}
					description={profileUser?.profile_info ?? ""}
					credentialCount={
						certificates.filter((cert) => cert.url !== "").length +
						certificates.filter((badge) => badge.badgeUrl !== "").length
					}
					bannerUrl={userWalletData?.profileBannerImageUrl}
					imageUrl={profileUser?.profile_url ?? NoUserAvatar}
					editModeActive={editModeActive}
					getBase64={getBase64}
					cancelEditMode={cancelEditMode}
					enterEditMode={enterEditMode}
					goToCredentials={goToCredentials}
					updateWalletProfile={updateWalletProfile}
					isLoading={profileLoading}
					isLoggedInUserProfile={isLoggedInUserProfile}
					activeTab={activeTab}
					addTranslation={props.addTranslation}
					isMobile={props.isMobile}
					linkedinProfileUrl={linkedinProfileUrl}
				/>
				<ProfileTabs
					{...props}
					editModeActive={editModeActive}
					isMobile={props.isMobile}
					certificates={certificates.filter((cert) => cert.url !== "")}
					badges={certificates.filter((badge) => badge.badgeUrl !== "")}
					userFullName={userFullName}
					userPhoto={userPhoto}
					goToCredentials={goToCredentials}
					isLoading={profileLoading}
					activeLanguage={props.activeLanguage}
					setCredentialsToBeUpdated={setCredentialsToBeUpdated}
					isLoggedInUserProfile={isLoggedInUserProfile}
					profileCredentials={credentials}
					activeTab={activeTab}
					setActiveTab={setActiveTab}
				/>
			</div>
		) : (
			<NotFound errorMessage={"notFound1"} />
		);
	}
};

export default withLocalize(Credentials);
